import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { compareAsc, format, addMonths } from 'date-fns'
import Skills from "./Skills/Skills";
import { httpCreateUserGroup } from './Skills/api/calls';
import { httpCreateSubSkill, getSkillByDeptID } from '../HR/Skills/subSkills/api/calls';
import { httpCreateGroup } from '../HR/Skills/SkillGroup/api/calls';
import Select from 'react-select'


let reporting_option = []
let finalreport_option = []
function AddEmployeeCom() {
	const salutationRef = useRef();
	const fnameRef = useRef();
	const peremailRef = useRef();
	const timezoneRef = useRef();
	const dobRef = useRef();
	const companyRef = useRef();
	const divisionRef = useRef();
	const deptRef = useRef();
	const dofjRef = useRef();
	const designationjRef = useRef();
	const empcatRef = useRef();
	const empshiftRef = useRef();
	const systemRoleRef = useRef();
	const newworklocationRef = useRef();
	const skillRef = useRef();

	let navigate = useNavigate();
	let SERVER_URL = process.env.REACT_APP_API_URL;
	let BASE_URL = process.env.REACT_APP_APP_URL;
	let token = JSON.parse(localStorage.getItem('key'));

	const [skillData, setUserSkillData] = useState([]);

	const [salutation, setSalutation] = useState('');
	const [fname, setFname] = useState('');
	const [mname, setMname] = useState('');
	const [lname, setLname] = useState('');
	const [gargen, setGargen] = useState('');
	const [gender, setGender] = useState('');
	const [dateofbirth, setDateofbirth] = useState('');
	const [marriage, setMarriage] = useState('');
	const [bloodgroup, setBloodgroup] = useState('');
	const [nationality, setNationality] = useState('');
	// const [adhaarname, setAdhaarname] = useState('');
	const [adhaarnumber, setAdhaarnumber] = useState('');
	const [pancardnumber, setPancardnumber] = useState('');
	const [company, setCompany] = useState('');
	const [division, setDivision] = useState('');
	const [department, setDepartment] = useState('');

	const [empcode, setEmpcode] = useState('');
	const [empstatus, setEmpstatus] = useState('');
	const [dateofjoining, setDateofjoining] = useState('');
	const [probation_period, setProbation_period] = useState('6');
	const [confirmationdate, setConfirmationdate] = useState('');

	const [designation, setDesignation] = useState('');
	const [empcategory, setEmpcategory] = useState('');
	const [noticeperiod, setNoticeperiod] = useState('');

	const [salaryType, setSalaryType] = useState('');
	const [ctc, setCtc] = useState('');
	const [bankname, setBankname] = useState('');
	const [accountnumber, setAccountnumber] = useState('');
	const [ifsc, setIfsc] = useState('');
	const [pfapplicable, setPfapplicable] = useState('');
	const [pfnumber, setPfnumber] = useState('');
	const [pfgroup, setPfgroup] = useState('');
	const [uan_number, setUan_number] = useState('');
	// const [pt_applicable, setPt_applicable] = useState('');

	const [role, setRole] = useState('');
	const [depdata, setDepdata] = useState([]);
	const [roledata, setRoledata] = useState([]);
	const [comdata, setComdata] = useState([]);

	const [color, setColor] = useState('');
	const [errmsg, setErrmsg] = useState('');
	const [buttonstatus, setbuttonstatus] = useState(true);
	const [persona_email, setPersonal_email] = useState('');
	const [contact_number, setContact_number] = useState('');
	const [timezone, setTimezone] = useState('');
	// const [officialemailstatus, setOfficialemailstatus] = useState(true);


	const [err, setErr] = useState('');
	const [errMsgsalutaion, setErrMsgsalutaion] = useState('');
	const [errMsgfname, setErrMsgfname] = useState('');
	const [errMsgpersona_email, setErrMsgpersona_email] = useState('');
	const [errMsgTimezone, setErrMsgTimezone] = useState('')
	const [errMsgdateofbirth, setErrMsgdateofbirth] = useState('')
	const [errMsgsysRole, setErrMsgsysRole] = useState('');
	const [errMsgcompany, setErrMsgcompany] = useState('');
	const [errMsgdivision, setErrMsgdivision] = useState('')
	const [errMsgdepartment, setErrMsgdepartment] = useState('');
	const [errMsgdateofjoining, setErrMsgdateofjoining] = useState('');
	const [errMsgdesignation, setErrMsgdesignation] = useState('');
	const [errMsgempcat, setErrMsgempcat] = useState('');
	const [errMsgShift, setErrMsgShift] = useState('');
	const [reportingmanager, setreportingmanager] = useState('');
	const [finalReport, setFinalReport] = useState('');
	const [systemRole, setSystemRole] = useState('');
	const [shift, setShift] = useState('');
	const [workplace, setWorkplace] = useState('');
	const [countrycode, setCountrycode] = useState('');
	const [shiftList, setShiftList] = useState([]);
	const [complist, setComplist] = useState([]);
	const [countrylist, setCountrylist] = useState([]);
	const [system_role, setSystem_role] = useState([]);
	const [CountryINWish, setIsHiddenIndia] = useState('');
	const [country, setCountry] = useState('');
	useEffect(() => {
		getCompanyList()
		getDepartmentList()
		getReportingManager()
		getShiftList()
		getCountryList()
		getSystemRole()
	}, [])

	const getSystemRole = () => {
		const response = fetch(SERVER_URL + `api/common/sytem-role`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => {
				setSystem_role(data.result)
			});
	}
	const getCountryList = () => {
		const response = fetch(SERVER_URL + `api/common/country_list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setComplist(data.result)
					setCountrylist(data.result)

				}
			});
	}
	const getShiftList = () => {
		const response = fetch(SERVER_URL + `api/common/getshiftlist`,
			{
				method: 'post',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				body: JSON.stringify({
					emailpersonal: persona_email,
					city: '',
				}),
			}).then(res => res.json())
			.then(data => {
				setShiftList(data.result)
			})
	}
	const [reportimgManageList, setReportimgManageList] = useState([]);
	const [finalReportList, setFinalReportList] = useState([]);
	const getReportingManager = () => {
		const response = fetch(SERVER_URL + `api/common/manager_list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},

			}).then(res => res.json())
			.then(data => {
				setReportimgManageList(data.result)
				setFinalReportList(data.result)
				reporting_option = []
				finalreport_option = []
				data?.result.map((row) => {
					reporting_option.push({ value: row.id, label: row.name + ' (' + row.user_code + ')' })
					finalreport_option.push({ value: row.id, label: row.name + ' (' + row.user_code + ')' })
				})
			});
	}


	const getCompanyList = () => {
		const response = fetch(SERVER_URL + `api/common/company_list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},

			}).then(res => res.json())
			.then(data => {
				setComdata(data.result)
			});
	}
	const getDepartmentList = () => {
		const response = fetch(SERVER_URL + `api/common/department_list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => {
				setDepdata(data.result)
			});
	}
	function handleChange(deptid) {
		setDepartment(deptid)
		if (deptid == '') {
			return false;
		} else {
			const response = fetch(SERVER_URL + `api/common/get_department_role`,
				{
					method: 'PUT',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'authorization': `bearer ${token.value}`
					},
					body: JSON.stringify({
						id: deptid,
					}),
				}).then(res => res.json())
				.then(data => {
					setRoledata(data.result)
				});
		}
	}
	const userSkillParentCallback = (userSkillChildData) => {
		setUserSkillData(userSkillChildData)
	}
	const [errSkill, setErrSkill] = useState('');
	const handleAddEMP = () => {
		var usernameRegex = /^([a-zA-Z0-9](_|-| )[a-zA-Z0-9])*[a-zA-Z0-9]+$/;
		let regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
		setErrMsgsalutaion('')
		setErrMsgfname('')
		setErrMsgpersona_email('')
		setErrMsgdateofbirth('')
		setErrMsgsysRole('')
		setErrMsgcompany('')
		setErrMsgdivision('')
		setErrMsgdepartment('')
		setErrMsgdateofjoining('')
		setErrMsgdesignation('')
		setErrMsgempcat('')
		setErr('')
		setErrSkill('')
		setErrdesignation('')
		setErrrole('')
		setEmp_profile(0)
		setEmp_spc(0)
		setEmp_dtl(0)
		if (company == '' || company == null || company == undefined) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgcompany('red')
			companyRef.current.focus();
			return false;
		}
		else if (department == '' || department == null || department == undefined || deptRef.current == '' || deptRef.current == null) {
			setEmp_profile(1)
			// setErr('red')
			setErrrole('red')
			deptRef?.current?.focus();
			return false;
		}
		else if (designation == '' || designation == null || designation == undefined || designationjRef.current == '' || designationjRef.current == null) {
			setSub_dept_status('block')
			setEmp_profile(1)
			// setErr('red')			
			setErrdesignation('red')
			designationjRef?.current?.focus();
			return false;
		}
		else if (skill == '' || skill == null || skill == undefined || skillRef.current == '' || skillRef.current == null) {
			setEmp_profile(1)
			setErrSkill('red')
			setSkill_status('block')
			skillRef?.current?.focus();
			return false;
		}
		else if (empcategory == '' || empcategory == null || empcategory == undefined) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgempcat('red')
			empcatRef.current.focus();
			return false;
		}
		else if (systemRole == '' || systemRole == null || systemRole == undefined) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgsysRole('red')
			systemRoleRef.current.focus();
			return false;
		}
		else if (salutation == '' || salutation == null || salutation == undefined) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgsalutaion('red')
			salutationRef.current.focus();
			return false;
		}
		else if (!usernameRegex.test(fname)) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgfname('red')
			fnameRef.current.focus();
			return false;
		}
		else if (!regEmail.test(persona_email)) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgpersona_email('red')
			peremailRef.current.focus();
			return false;
		}

		else if (timezone == '' || timezone == null || timezone == undefined) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgTimezone('red')
			timezoneRef.current.focus();
			return false;
		}
		else if (shift == '' || shift == null || shift == undefined) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgShift('red')
			empshiftRef.current.focus();
			return false;
		}
		else if ((dateofbirth == '' || dateofbirth == null || dateofbirth == undefined) && company == 1) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgdateofbirth('red')
			dobRef.current.focus();
			return false;
		}
		// else if (division == '') {
		// 	setEmp_spc(1)
		// 	setErr('red')
		// 	setErrMsgdivision('This field is required')
		// 	divisionRef.current.focus();
		// 	return false;
		// } 
		else if (empcategory == '') {
			setEmp_spc(1)
			setErr('red')
			setErrMsgempcat('This field is required')
			empcatRef.current.focus();
			return false;
		}

		// else if (department == '') {
		// 	setEmp_spc(1)
		// 	setErr('red')
		// 	setErrMsgdepartment('This field is required')
		// 	deptRef.current.focus();
		// 	return false;
		// } 
		else if (dateofjoining == '') {
			setEmp_spc(1)
			setErr('red')
			setErrMsgdateofjoining('red')
			dofjRef.current.focus();
			return false;


		}

		else {
			setbuttonstatus(false)
			const date = new Date();
			const date_formate = format(date, 'yyyy-MM-dd HH:m:ss')
			const userId = localStorage.getItem('userId');


			const response = fetch(SERVER_URL + `api/employee/add`,
				{
					method: 'post',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'authorization': `bearer ${token.value}`
					},
					body: JSON.stringify({
						emailpersonal: persona_email ? persona_email : '',
						city: '',
						state: state ? state : '',
						country: country,
						pincode: '',
						add: '',
						contact: contact_number,
						timezone: timezone,
						workplace: workplace ? workplace : '',
						salutation: salutation,
						fname: fname,
						mname: mname,
						lname: lname,
						gurgaon: gargen,
						gender: gender,
						dateofbirth: dateofbirth,
						marriage: marriage,
						bloodgroup: bloodgroup,
						nationality: nationality,

						country_code: countrycode,
						pancardnumber: pancardnumber,
						adhaarnumber: adhaarnumber,
						comp: company,
						division: division,
						dept: department,
						empcode: empcode,
						status: empstatus,
						joiningdate: dateofjoining,
						probation_period: probation_period,
						confirmationdate: confirmationdate,
						role: designation,
						skill: skill,
						reporting_manager: reportingmanager,
						finalreporting: finalReport,
						noticeperiod: noticeperiod,
						salaryType: salaryType,
						ctc: ctc,
						bankname: bankname,
						accountnumber: accountnumber,
						ifsc: ifsc,
						pfapplicable: pfapplicable,
						pfnumber: pfnumber,
						pfgroup: pfgroup,
						// pt_applicable: pt_applicable,
						uan_number: uan_number,
						systemRole: systemRole,
						usertype: empcategory,
						created_on: date_formate,
						created_by: userId,
						shift: shift
					}),
				}).then(res => res.json())
				.then(data => {
					setbuttonstatus(false)
					if (data.status === true) {
						addUserSkill(data.lastID);
						setErrmsg('Employee, Successfully Added')
						setColor('green')
						setTimeout(function () {
							navigate("/employeelist");
						}, 1000);
					} else {
						setErrmsg('Error! Something went wrong')
						setbuttonstatus(false)
						setColor('red')
					}
				})

		}
		const addUserSkill = (id) => {
			if (skillData) {
				const userSkill = {
					user_id: id,
					skillData
				}
				httpCreateUserGroup(userSkill)
			}
		}
	}
	// const handleEmail = () => {
	// 	setOfficialemailstatus(!officialemailstatus)
	// }
	const [emp_profile, setEmp_profile] = useState(1);
	const [emp_spc, setEmp_spc] = useState(0);
	const [emp_dtl, setEmp_dtl] = useState(0);
	const [emp_skill, seEmp_skill] = useState(0);
	const handleTab = (tab_id) => {
		setEmp_profile(0)
		setEmp_spc(0)
		setEmp_dtl(0)
		seEmp_skill(0)
		if (tab_id == 1) {
			setEmp_profile(tab_id)
		} else if (tab_id == 2) {
			setEmp_spc(tab_id)
		}
		else if (tab_id == 3) {
			setEmp_dtl(tab_id)
		}
		else if (tab_id == 4) {
			seEmp_skill(tab_id)
		}
	}
	const [locationlist, setLocationlist] = useState([])

	const getLocation = async (id) => {
		const response = await fetch(SERVER_URL + `api/common/time-zone-list?countryId=${id}`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setLocationlist(data.result)
				}
			})
	}
	const [workLocationlist, setWorkLocationlist] = useState([])
	const getWorkLocation = async (state) => {
		const response = await fetch(SERVER_URL + `api/common/getworkLocation?stateid=${state}`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setWorkLocationlist(data.result)
				}
			})
	}
	const handleDepartment = (val) => {

		setDepartment(val)
		setSkillList([])
		getSkillByDeptID(val).then((res) => {
			if (res.status) {
				setRoledata(res.data);
			}
		})
	}

	const [sub_dept_status, setSub_dept_status] = useState('block');
	const handleAddSubRole = () => {
		setSub_dept_status(sub_dept_status == 'block' ? 'none' : 'block')
	}
	const [errrole, setErrrole] = useState('');
	const [errsubrole, setErrsubrole] = useState('');
	const [newSubrole, setNewSubrole] = useState('');
	const [sub_role, setSub_Role] = useState('');


	const handleSaveSubRole = () => {
		setErrrole('')
		setErrsubrole('')
		if (department == '') {
			setErrrole('red')
			return false;
		} if (newSubrole == '') {
			setErrsubrole('red')
			return false;
		}
		else {
			check_department(department, newSubrole)
			//add_new_sub_role(department, newSubrole)
		}
	}

	const [errcheckrole, setErrcheckrole] = useState('');
	const check_department = (department, newSubrole) => {
		setErrcheckrole('')
		setErrsubrole('')
		const response = fetch(SERVER_URL + `api/common/checkdepartment`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				body: JSON.stringify({
					role: department,
					name: newSubrole,
				})
			}).then(res => res.json()).then(data => {

				if (data.status == true) {
					//console.log(data?.result.total)
					if (data?.result.total > 0) {
						setErrcheckrole('Already exists')
						setErrsubrole('red')

						return false
					} else {
						add_new_sub_role(department, newSubrole)
					}
				}
			})

	}

	const add_new_sub_role = (department, newSubrole) => {
		const user_login_id = localStorage.getItem('userId')
		const date = new Date();
		const date_formate = format(date, 'yyyy-MM-dd HH:m:SS')
		const response = fetch(SERVER_URL + `api/common/add_department`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				body: JSON.stringify({
					role: department,
					name: newSubrole,
					code: '',
					created_on: date_formate,
					created_by: user_login_id,
				})
			}).then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setDepartment(department)
					//handleChange(department)
					setSub_dept_status('block')
					setSub_Role('')

					setNewSubrole('')
					getSkillByDeptID(department).then((res) => {
						if (res.status) {
							setRoledata(res.data);
						}
					})
				}
			})

	}
	const handleCancelSubRole = () => {
		setNewSubrole('')
		setSub_dept_status(sub_dept_status == 'none' ? 'block' : 'none')
		setErrcheckrole('');
		setErrsubrole('')
	}

	const [newworklocation, setNewworklocation] = useState('');
	const [location_status, setLocation_status] = useState('block');
	const handleWorkLocation = () => {
		setLocation_status(location_status == 'none' ? 'block' : 'none')
	}
	const handleCancellocation = () => {
		setLocation_status(location_status == 'none' ? 'block' : 'none')
		setNewworklocation('');
	}
	const [errwrklsn, setErrwrklsn] = useState('');
	const [errstate, setErrstate] = useState('');
	const handleSaveLocation = () => {
		setErrwrklsn('')
		setErrstate('');
		const user_login_id = localStorage.getItem('userId')
		const date = new Date();
		const date_formate = format(date, 'yyyy-MM-dd HH:m:SS')
		if (state == '' || state == null || state == undefined) {
			setErrstate('red')
			return false;
		}
		if (newworklocation == '' || newworklocation == null) {
			setErrwrklsn('red')
			newworklocationRef.current.focus();
			return false;
		} else {
			const response = fetch(SERVER_URL + `api/common/add_workLocation`,
				{
					method: 'POST',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'authorization': `bearer ${token.value}`
					},
					body: JSON.stringify({
						state: state,
						location: newworklocation,
						created_on: date_formate,
						created_by: user_login_id,
					})
				}).then(res => res.json())
				.then(data => {
					if (data.status == true) {
						setNewworklocation('');
						setLocation_status('block')
						setWorkplace('');
						getWorkLocation(state)
					}
				})
		}
	}

	const handleChangeNumber = (e) => {
		if (!isNaN(Number(e.target.value))) {
			setContact_number(e.target.value);
		}
	};

	const handleDegination = (e) => {
		setDesignation(e.target.value)
		getSkills_list(e.target.value)
	}
	const [skillList, setSkillList] = useState([]);
	const getSkills_list = (id) => {
		const response = fetch(SERVER_URL + `api/common/getSkillsList?id=${id}`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setSkillList(data.data)
				}
			})
	}
	const [skill, setSkill] = useState('');
	const [errskill, setErrskill] = useState('');
	const [errdesignation, setErrdesignation] = useState('');
	const [newSkill, setNewSkill] = useState('');
	const [skill_status, setSkill_status] = useState('block');
	const handleAddSkill = () => {
		setSkill_status(skill_status == 'block' ? 'none' : 'block')
		setNewSubrole('')
		setErrskill('')
		setErrcheckskill('')
	}
	const handleSaveSkill = () => {
		setErrskill('');
		setErrdesignation('');
		if (designation == '' || designation == null || designation == undefined) {
			setErrdesignation('red')
			designationjRef.current.focus();
			return false;

		} else if (newSkill == '' || newSkill == null || newSkill == undefined) {
			setErrskill('red')
			return false;
		} else {
			check_skill(designation, newSkill)
		}
	}

	const [errcheckskill, setErrcheckskill] = useState('');
	const check_skill = (designation, newSkill) => {
		setErrskill('')
		setErrcheckskill('')
		const response = fetch(SERVER_URL + `api/common/checkskill`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				body: JSON.stringify({
					id: designation,
					name: newSkill,
				})
			}).then(res => res.json()).then(data => {
				if (data.status == true) {
					if (data?.result.total > 0) {
						setErrskill('red')
						setErrcheckskill('Already Exist')
					} else {
						httpCreateSubSkill({ name: newSkill, group_id: designation }).then((res) => {
							if (res.status) {
								getSkills_list(designation)
								setSkill_status('block');
								setNewSkill('')
							}
						});
					}
				}
			})
	}
	const handleCancelSkill = () => {
		setSkill_status(skill_status == 'block' ? 'none' : 'block')
		setNewSkill('');
		setNewSubrole('')
	}

	const [state, setState] = useState('');
	const [statelist, setStatelist] = useState([]);

	const getStateByCID = async (id) => {
		const response = await fetch(SERVER_URL + `api/common/state?countryId=${id}`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setStatelist(data.result)
				}
			})
	}
	const handleCountry = (id) => {
		setCountry(id)
		getLocation(id)
		getStateByCID(id)
	}
	const HandleCompany = (e) => {
		setErrMsgcompany('')
		setCompany(e.target.value)

		let cid = '';
		if (e.target.value == 1 || e.target.value == 2) {
			cid = '1'
		}
		if (e.target.value == 3 || e.target.value == 5) {
			cid = '2'
		}
		if (e.target.value == 6) {
			cid = '3'
		}
		handleCountry(cid)
	}
	const HandleState = (e) => {
		setState(e.target.value)
		getWorkLocation(e.target.value)
	}
	useEffect(() => {
		setErrMsgdepartment('')
		setErrMsgdesignation('')
		setErrSkill('')
		setErrMsgempcat('')
		setErrMsgsysRole('')
		setErrMsgsalutaion('')
		setErrMsgTimezone('')
		setErrMsgShift('')
	}, [department, designation, skill, empcategory, systemRole, salutation, timezone, shift])



	const HandleDateOfJoining = (e) => {
		setDateofjoining(e.target.value)
		const period = new Date(e.target.value)
		const end = addMonths(period, 6)
		const confDate = format(end, 'yyyy-MM-dd')
		setConfirmationdate(confDate)


		var date1 = new Date(dateofjoining);
		var date2 = new Date(confirmationdate);
		if (dateofjoining) {
			var year1 = date1.getFullYear();
			var year2 = date2.getFullYear();
			var month1 = date1.getMonth();
			var month2 = date2.getMonth();
			const numberOfMonths = (year2 - year1) * 12 + (month2 - month1);
			setProbation_period(numberOfMonths)
		}
	}

	const [save_status, setSave_status] = useState('')
	const [checkemail, setCheckemail] = useState('')
	const HandlePerEmail = (e) => {
		setPersonal_email(e.target.value)
		VerifyEmail(e.target.value)
		setCheckemail('')
		setSave_status('')
	}
	const VerifyEmail = (checkemail) => {
		if (checkemail.includes(".") && checkemail.includes("@")) {
			const response = fetch(SERVER_URL + `api/common/checkemail?email=${checkemail}`,
				{
					method: 'GET',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'authorization': `bearer ${token.value}`
					},
				}).then(res => res.json())
				.then(data => {
					if (data.status == true) {
						// console.log(data.result)
						if (data?.result?.total > 0) {
							setCheckemail('email already in use')
							setSave_status('disabled')
							return false;
						}
					}
				})

		}
	}

	function monthDiff(dateFrom, dateTo) {

	}


	const HandleConfirmationDate = (e) => {
		setConfirmationdate(e.target.value)
		var date1 = new Date(dateofjoining);
		var date2 = new Date(confirmationdate);

		if (dateofjoining) {
			var year1 = date1.getFullYear();
			var year2 = date2.getFullYear();
			var month1 = date1.getMonth();
			var month2 = date2.getMonth();
			const numberOfMonths = (year2 - year1) * 12 + (month2 - month1);
			setProbation_period(numberOfMonths)
		}

	}
	const HandleSystemRole = (e) => {
		setSystemRole(e.target.value)
		if (e.target.value == 1) {
			setNoticeperiod('30')
		} else {
			setNoticeperiod('60')
		}
	}
	const HandleAdhaar = (e) => {
		if (!isNaN(Number(e.target.value))) {
			setAdhaarnumber(e.target.value)
		}
	}
	const HandleEpmCode = (e) => {
		setEmpcode(e.target.value)

		if (e.target.value.length > 2) {
			verifyEmpCode(e.target.value)
		}
	}
	const [checkempcode, setCheckempcode] = useState('');
	const verifyEmpCode = (empCode) => {
		setSave_status('')
		const response = fetch(SERVER_URL + `api/common/check-emp-code`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				body: JSON.stringify({
					empCode: empCode,
				})
			}).then(res => res.json()).then(data => {
				if (data.status == true) {
					setCheckempcode(data?.result?.total);
					if (data?.result?.total > 0) {
						setSave_status('disabled')
					}
				}
			})
	}



	return (
		<>

			<div className="page-header">
				<h1>Add Employee</h1>
				<ul id="breadcrumbs" className="breadcrumb mb00">
					<li>
						<Link to="/dashboard">Dashboard </Link>
					</li>
					<li>
						<Link to='/employeelist'><span>/</span>Employee List </Link>
					</li>
					<li className="current">
						<span>/</span>Add Employee
					</li>
				</ul>
			</div>

			<div className="row_bg">
				<div className="profile_wrapper mb30">
					<div className="nav" id="profile-tab" role="tablist" aria-orientation="vertical">

						<Link className={`nav-link ${emp_profile ? 'active' : ''}`} onClick={(e) => { handleTab(1) }}>
							Employment Profile
						</Link>
						<span className="middleline"></span>
						<Link className={`nav-link ${emp_spc ? 'active' : ''}`} onClick={(e) => { handleTab(2) }}>
							Employment Specifics
						</Link>
						<span className="middleline"></span>
						<Link className={`nav-link ${emp_dtl ? 'active' : ''}`} onClick={(e) => { handleTab(3) }}>
							Other Detail
						</Link>
					</div>
					<div className="tab-content" id="profile-tabContent">
						<div className={`tab-pane fade ${emp_profile ? 'show active' : ''}`} id="employmentprofile" role="tabpanel" aria-labelledby="employmentprofile-tab">
							<div className="tab_content">
								<div className="tab_sub_ttl">Organization</div>

								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Company <sup className="error_mgs"> *</sup></div>
											<div className="form-input col-md-8 relative">
												<span className="error_mgs1" style={{ color: err }}></span>
												<select style={{ 'borderColor': `${errMsgcompany}` }} ref={companyRef} value={company} onChange={HandleCompany} className="form-select">
													<option value=''>Select Company</option>
													{
														comdata?.map((item, ind) => (
															<option key={ind} value={item.id}>{item.name}</option>
														))}
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4"> Division <sup className="error_mgs"> *</sup></div>
											<div className="form-input col-md-8 relative">
												<span className="error_mgs1" style={{ color: err }}></span>
												<select style={{ 'borderColor': `${errrole}` }} ref={deptRef} value={department} onChange={e => handleDepartment(e.target.value)} className="form-select">
													<option value=''>Select Division </option>
													{
														depdata?.map((item, ind) => (
															<option key={ind} value={item.id}>{item.name}</option>
														))}
												</select>
											</div>
										</div>
									</div>
									{sub_dept_status == 'block' &&
										<div className="col-md-6">
											<div className="form-blk row mb25">
												<div className="form-label col-md-4">Department  <sup className="error_mgs"> *</sup></div>
												<div className="form-input col-md-8 addnew_wrapper relative">

													<select style={{ 'borderColor': `${errdesignation}` }} ref={designationjRef} value={designation} onChange={handleDegination} className="form-select ucwords">
														<option value=''>Select Department </option>
														{
															roledata?.map((item, ind) => (
																<option key={ind} value={item.id}>{item.name}</option>
															))
														}
													</select>

													<button className="addnew_btn" onClick={handleAddSubRole}> Add</button>
													<div className="error_mgs1" style={{ color: err }}></div>
												</div>
											</div>
										</div>
									}
									{sub_dept_status == 'none' &&
										<div className="col-md-6" >
											<div className="form-blk row mb25" >
												<div className="form-label col-md-4"> Department</div>
												<div className="form-input col-md-8 addnew_wrapper1">
													<input style={{ 'borderColor': `${errsubrole}` }} type="text" value={newSubrole} onChange={(e) => setNewSubrole(e.target.value)} placeholder="Enter Sub Department" className="form-control form-control1" />
													<button className="addnew_btn1" onClick={handleSaveSubRole}> Save</button>
													<button className="cancelnew_btn" onClick={handleCancelSubRole}> Cancel</button>
													<div style={{ color: 'red' }}>{errcheckrole}</div>
												</div>

											</div>
										</div>}
									{skill_status == 'block' &&
										<div className="col-md-6">
											<div className="form-blk row mb25">
												<div className="form-label col-md-4">Skills <sup className="error_mgs"> *</sup></div>
												<div className="form-input col-md-8 addnew_wrapper relative">
													<span className="error_mgs1"></span>
													<select ref={skillRef} style={{ 'borderColor': `${errSkill}` }} value={skill} className="form-select" onChange={e => setSkill(e.target.value)}>
														<option value=''>Select Skills</option>
														{
															skillList?.map((item, i) => (
																<option value={item.id} key={item.id}>{item.name}</option>
															))
														}
													</select>
													<button className="addnew_btn" onClick={handleAddSkill}> Add</button>
												</div>
											</div></div>}
									{skill_status == 'none' &&
										<div className="col-md-6" >
											<div className="form-blk row mb25" >
												<div className="form-label col-md-4"> Skills</div>
												<div className="form-input col-md-8 addnew_wrapper1">
													<input style={{ 'borderColor': `${errskill}` }} type="text" value={newSkill} onChange={(e) => setNewSkill(e.target.value)} placeholder="Enter skills" className="form-control form-control1" />
													<button className="addnew_btn1" onClick={handleSaveSkill}> Save</button>
													<button className="cancelnew_btn" onClick={handleCancelSkill}> Cancel</button>
													<div style={{ color: 'red' }}>{errcheckskill}</div>
												</div>
											</div>
										</div>}

									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Employment Mode <sup className="error_mgs"> *</sup></div>
											<div className="form-input col-md-8 relative">
												<span className="error_mgs1" ></span>
												<select style={{ 'borderColor': `${errMsgempcat}` }} ref={empcatRef} value={empcategory} onChange={(e) => setEmpcategory(e.target.value)} className="form-select">
													<option value=''>Select Employment Mode</option>
													<option value='1'>Payroll</option>
													<option value='2'>Contract</option>
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">System Role <sup className="error_mgs"> *</sup></div>
											<div className="form-input col-md-8 relative">
												<span className="error_mgs1" style={{ color: err }}></span>
												<select style={{ 'borderColor': `${errMsgsysRole}` }} ref={systemRoleRef} className="form-select" onChange={HandleSystemRole}>
													<option value=''>Select System Role</option>
													{
														system_role?.map((item, ind) => (
															<option key={ind} value={item.id}>{item.role}</option>
														))}
												</select>
											</div>
										</div>
									</div>

								</div>





								<div className="row mb25">
									<div className="tab_sub_ttl">Basic Info</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Salutation <sup className="error_mgs"> *</sup></div>
											<div className="form-input col-md-8 relative">
												<span className="error_mgs1" ></span>
												<select style={{ 'borderColor': `${errMsgsalutaion}` }} ref={salutationRef} value={salutation} onChange={(e) => { setSalutation(e.target.value) }} className="form-select">
													<option value=''>Select</option>
													<option value='1'>Mr</option>
													<option value='2'>Ms</option>
													<option value='3'>Mrs</option>
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">First Name  <sup className="error_mgs"> *</sup></div>
											<div className="form-input col-md-8 relative">
												<input style={{ 'borderColor': `${errMsgfname}` }} ref={fnameRef} autoComplete="none" value={fname} onChange={(e) => { setFname(e.target.value) }} type="text" placeholder="Enter First Name" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Middle Name</div>
											<div className="form-input col-md-8">
												<input autoComplete="none" value={mname} onChange={(e) => { setMname(e.target.value) }} type="text" placeholder="Enter Middle Name" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Last Name</div>
											<div className="form-input col-md-8">
												<input autoComplete="none" value={lname} onChange={(e) => { setLname(e.target.value) }} type="text" placeholder="Enter Last Name" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Personal Email  <sup className="error_mgs"> * </sup></div>
											<div className="form-input col-md-8 relative">
												<input style={{ 'borderColor': `${errMsgpersona_email}` }} ref={peremailRef} autoComplete="none" value={persona_email} onChange={HandlePerEmail} type="text" placeholder="Enter Personal Email" className="form-control form-control1 lowercase" />
												<div className="error_mgs">{checkemail}</div>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Contact Number </div>
											<div className="form-input col-md-8 countrycode_wrp">
												<select className="form-select" onChange={e => setCountrycode(e.target.value)}>
													<option value=''>Select</option>
													{
														complist.map((item, i) =>
															<option key={i} value={item.id} >{item.phonecode}</option>
														)
													}

												</select>
												<input autoComplete="none" value={contact_number} onChange={handleChangeNumber} type="text" placeholder="Enter Contact Number" className="form-control form-control1 only-numeric" />
											</div>
										</div>
									</div>
									{/* <div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Official Email </div>
										<div className="form-input col-md-8">
											<input checked={officialemailstatus ? 'checked' : ''} onChange={handleEmail} onc type="checkbox" /> Create Yes/No
										</div>
									</div>
								</div>
							</div> */}
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Father/Husband</div>
											<div className="form-input col-md-8">
												<input value={gargen} autoComplete="none" onChange={(e) => { setGargen(e.target.value) }} type="text" placeholder="Enter Father/Husband Name" className="form-control form-control1" />
											</div>
										</div>
									</div>

									<div className="tab_sub_ttl">Location</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Country</div>
											<div className="form-input col-md-8">
												<select disabled value={country} onChange={handleCountry} className="form-select">
													<option value="">Select Country</option>
													{
														countrylist.map((item, ind) => {
															return <option key={ind} value={item.id}>{item.name}</option>
														})
													}
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Time Zone <sup className="error_mgs"> *</sup></div>
											<div className="form-input col-md-8 relative">
												<select style={{ 'borderColor': `${errMsgTimezone}` }} ref={timezoneRef} value={timezone} onChange={e => setTimezone(e.target.value)} className="form-select" placeholder='Select Time Zone'>
													<option value=''>Select Time Zone</option>
													{locationlist?.map((item, ind) =>
														<option key={item.location_id} value={item.location_id}>{item.name} {item.timezone}</option>
													)}
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">State</div>
											<div className="form-input col-md-8">
												<select style={{ 'borderColor': `${errstate}` }} value={state} onChange={HandleState} className="form-select">
													<option value="">Select State</option>
													{
														statelist.map((item, ind) => {
															return <option key={ind} value={item.id}>{item.name}</option>
														})
													}
												</select>
											</div>
										</div>
									</div>
									{location_status == 'block' &&
										< div className="col-md-6">
											<div className="form-blk row mb25">
												<div className="form-label col-md-4">Work Location</div>
												<div className="form-input col-md-8 addnew_wrapper">
													<select className="form-select" onChange={(e) => { setWorkplace(e.target.value) }}>
														<option value=''>Select Work Location</option>
														{
															workLocationlist.map((item, ind) => {
																return <option key={item.id} value={item.id}>{item.name}</option>
															})
														}
													</select>
													<button className="addnew_btn" onClick={handleWorkLocation}> Add New</button>
												</div>
											</div>
										</div>
									}
									{location_status == 'none' && <div className="col-md-6" >
										<div className="form-blk row mb25" >
											<div className="form-label col-md-4">Work Location</div>
											<div className="form-input col-md-8 addnew_wrapper1">
												<input ref={newworklocationRef} style={{ 'borderColor': `${errwrklsn}` }} type="text" value={newworklocation} onChange={(e) => setNewworklocation(e.target.value)} placeholder="Enter work location" className="form-control form-control1" />
												<button className="addnew_btn1" onClick={handleSaveLocation}> Save</button>
												<button className="cancelnew_btn" onClick={handleCancellocation}> Cancel</button>
											</div>
										</div>
									</div>}
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Shift Time <sup className="error_mgs"> *</sup></div>
											<div className="form-input col-md-8 relative">
												<select style={{ 'borderColor': `${errMsgShift}` }} ref={empshiftRef} value={shift} className="form-select" onChange={(e) => { setShift(e.target.value) }}>
													<option value=''>Select Shift</option>
													{
														shiftList.map((item, ind) => {
															return <option key={item.id} value={item.id}>{item.Name}</option>
														})
													}
												</select>
											</div>
										</div>
									</div>
									{country == 1 ?
										<div className="col-md-6">
											<div className="form-blk row mb25">
												<div className="form-label col-md-4">Gender</div>
												<div className="form-input col-md-8">
													<select value={gender} onChange={(e) => { setGender(e.target.value) }} className="form-select">
														<option value="">Select Gender</option>
														<option value='1'>Male</option>
														<option value='2'>Female</option>
													</select>
												</div>
											</div>
										</div>
										: ''}
									{country == 1 ?
										<div className="col-md-6">
											<div className="form-blk row mb25">
												<div className="form-label col-md-4">Date Of Birth  <sup className="error_mgs"> *</sup></div>
												<div className="form-input col-md-8 relative">
													<input style={{ 'borderColor': `${errMsgdateofbirth}` }} ref={dobRef} onChange={(e) => { setDateofbirth(e.target.value) }} type="date" className="form-control" name="" value={dateofbirth} placeholder="Select Date Of Birth" />
												</div>
											</div>
										</div>
										: ''}
									{country == 1 ?
										<div className="col-md-6">
											<div className="form-blk row mb25">
												<div className="form-label col-md-4">Marital Status</div>
												<div className="form-input col-md-8">
													<select value={marriage} onChange={(e) => setMarriage(e.target.value)} className="form-select">
														<option value="">Select Marital Status</option>
														<option value='1'>Married</option>
														<option value='2'>Unmarried</option>
														<option value='3'>Other</option>
													</select>
												</div>
											</div>
										</div>
										: ''}
									{country == 1 ?
										<div className="col-md-6">
											<div className="form-blk row mb25">
												<div className="form-label col-md-4">Blood Group</div>
												<div className="form-input  col-md-8">
													<input type="text" value={bloodgroup} onChange={(e) => setBloodgroup(e.target.value)} placeholder="Enter Blood Group" className="form-control form-control1" />
												</div>
											</div>
										</div>
										: ''}


									{/* <div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Country</div>
											<div className="form-input col-md-8">

												<input type="text" value={nationality} onChange={(e) => setNationality(e.target.value)} placeholder="Enter Country" className="form-control form-control1" />
											</div>
										</div>
									</div> */}




									{/* <div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Aadhaar Name </div>
											<div className="form-input col-md-8">
												<input type="text" value={adhaarname} onChange={(e) => setAdhaarname(e.target.value)} placeholder="Enter Aadhaar Card Name" className="form-control form-control1" />
											</div>
										</div>
									</div> */}
									{country == 1 ?
										<div className="col-md-6">
											<div className="form-blk row mb25">
												<div className="form-label col-md-4">Aadhaar Number</div>
												<div className="form-input col-md-8">
													<input type="text" value={adhaarnumber} onChange={HandleAdhaar} placeholder="Enter Aadhaar Card Number" className="form-control form-control1 only-numeric" />
												</div>
											</div>
										</div>
										: ''}
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">{country == 1 ? 'Pan Number' : 'SSN'}</div>
											<div className="form-input col-md-8">
												<input value={pancardnumber} onChange={(e) => setPancardnumber(e.target.value)} type="text" placeholder={`Enter ${country == 1 ? 'Pan Number' : 'SSN'}`} className="form-control form-control1" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className={`tab-pane fade ${emp_spc ? 'show active' : ''}`} id="employmentspecifics" role="tabpanel" aria-labelledby="employmentspecifics-tab">
							<div className="tab_content">
								<div className="tab_sub_ttl">Employee Details</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Employee Code</div>
											<div className="form-input col-md-8">
												<input style={{ borderColor: checkempcode > 0 ? 'red' : '' }} type="text" value={empcode} onChange={HandleEpmCode} placeholder="Enter Employee Code" className="form-control form-control1" />
												<div style={{ color: 'red' }}>{checkempcode > 0 ? 'User Code already exist' : ''}</div>
											</div>
										</div>
									</div>

									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Employee Status</div>
											<div className="form-input col-md-8">
												<select value={empstatus} onChange={(e) => setEmpstatus(e.target.value)} className="form-select">
													<option value="">Select Employee Status</option>
													<option value='1'>Active</option>
													<option value='2'>Inactive</option>
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Date of joining <sup className="error_mgs"> *</sup></div>
											<div className="form-input col-md-8 relative">
												<input style={{ 'borderColor': `${errMsgdateofjoining}` }} ref={dofjRef} type="date" value={dateofjoining} onChange={HandleDateOfJoining} className="form-control" placeholder="Select Date of joining" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4 pr07">Probation Period (Month)</div>
											<div className="form-input col-md-8">
												<input type="text" disabled
													// onChange={(e) => setProbation_period(e.target.value)}
													value={probation_period} placeholder="Enter Probation Period (month)" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Confirmation Date</div>
											<div className="form-input col-md-8">
												<input value={confirmationdate} onChange={HandleConfirmationDate} type="date" className="form-control" placeholder="Select Confirmation Date" />
											</div>
										</div>
									</div>


									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4 pr07">Notice Period (Days) </div>
											<div className="form-input col-md-8">
												<input value={noticeperiod} disabled
													// onChange={(e) => setNoticeperiod(e.target.value)} 
													type="text" placeholder="Enter Notice Period" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">First Reporting  </div>
											<div className="form-input col-md-8">
												{/* <select value={reportingmanager} className="form-select" onChange={(e) => { setreportingmanager(e.target.value) }}>
													<option value=''>Select Reporting</option>
													{
														reportimgManageList.map((item, ind) => {
															return <option value={item.id}>{item.name}</option>
														})
													}
												</select> */}
												{/* <Select options={reporting_option} /> */}
												<Select onChange={(e) => { setreportingmanager(e.value) }} options={reporting_option} />
											</div>
										</div>
									</div>

								
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Final Reporting </div>
											<div className="form-input col-md-8">
												{/* <div className="form-check formcheck1">
													<input className="form-check-input" type="checkbox" value="" id="level1" />
													<label className="form-check-label" htmlFor="level1">
														Level 1
													</label>
												</div>
												<div className="form-check formcheck1">
													<input className="form-check-input" type="checkbox" value="" id="level2" />
													<label className="form-check-label" htmlFor="level2">
														Level 2
													</label>
												</div> */}
												{/* <select value={finalReport} className="form-select" onChange={(e) => { setFinalReport(e.target.value) }}>
													<option value=''>Select Reporting</option>
													{
														 finalReportList.map((item, ind) => {
															return <option value={item.id}>{item.name}</option>
														})
													}
												</select> */}
												<Select onChange={(e) => { setFinalReport(e.value) }} options={finalreport_option} />
											</div>
										</div>
									</div>


								</div>
							</div>
						</div>

						<div className={`tab-pane fade ${emp_dtl ? 'show active' : ''}`} id="detail" role="tabpanel" aria-labelledby="detail-tab">
							<div className="tab_content">
								<div className="tab_sub_ttl">Remuneration</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Salary Type</div>
											<div className="form-input col-md-8">
												<select className="form-select">
													<option value=''>Select Salary Type</option>
													<option value='1'>Monthly Basis</option>
													<option value='2'>Daily Basis</option>
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">CTC</div>
											<div className="form-input col-md-8">
												<input type="text" placeholder="Enter CTC" className="form-control form-control1" />
											</div>
										</div>
									</div>
								</div>
								<div className="tab_sub_ttl">Bank Details</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Salary Bank</div>
											<div className="form-input col-md-8">
												<select value={bankname} onChange={(e) => setBankname(e.target.value)} className="form-select">
													<option value=''>Select Salary Type</option>
													<option value='1'>HDFC Bank</option>
													<option value='2'>Federal Bank</option>
													<option value='3'>IDFC FIRST Bank</option>
													<option value='4'>RBL Bank</option>
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">Account Number</div>
											<div className="form-input col-md-8">
												<input value={accountnumber} onChange={(e) => setAccountnumber(e.target.value)} type="text" placeholder="Enter Salary Account Number" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">IFSC Code</div>
											<div className="form-input col-md-8">
												<input value={ifsc} onChange={(e) => setIfsc(e.target.value)} type="text" placeholder="Enter Salary IFSC Code" className="form-control form-control1" />
											</div>
										</div>
									</div>
									{/* <div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">PF Applicable</div>
											<div className="form-input col-md-8">
												<select value={pfapplicable} onChange={(e) => setPfapplicable(e.target.value)} className="form-select">
													<option value=''>Select PF Applicable</option>
													<option value='1'>Yes</option>
													<option value='2'>No</option>
												</select>
											</div>
										</div>
									</div> */}
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">PF Number</div>
											<div className="form-input col-md-8">
												<input value={pfnumber} onChange={(e) => setPfnumber(e.target.value)} type="text" placeholder="Enter PF Number" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">PF Group</div>
											<div className="form-input col-md-8">
												<select value={pfgroup} onChange={(e) => setPfgroup(e.target.value)} className="form-select">
													<option value=''>Select PF Group</option>
													<option value='1'>Yes</option>
													<option value='2'>No</option>
												</select>
											</div>
										</div>
									</div>
									{/* <div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">PT Applicable</div>
											<div className="form-input col-md-8">
												<select className="form-select" onChange={(e) => { setPt_applicable(e.target.value) }}>
													<option value=''>Select PT Group</option>
													<option value='1'>Yes</option>
													<option value='2'>No</option>
												</select>
											</div>
										</div>
									</div> */}
									<div className="col-md-6">
										<div className="form-blk row mb25">
											<div className="form-label col-md-4">UAN Number</div>
											<div className="form-input col-md-8">
												<input type="text" onChange={(e) => { setUan_number(e.target.value) }} placeholder="Enter UAN Number" className="form-control form-control1" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="tab_footer text-end">
							<span className="mr08" style={{ color: color ? color : '' }}>{errmsg}</span>
							<button disabled={save_status} style={{ display: buttonstatus == true ? '' : 'none' }} className="btn_5" onClick={e => handleAddEMP()}>Save</button>
							<button className="btn_6 ml10">Cancel</button>
						</div>
					</div>
				</div></div >
		</>
	)
}
export default AddEmployeeCom
